///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item = abcsetup.abc_item || {};
abcsetup.abc_item.request_pr_docs = abcsetup.abc_item.request_pr_docs || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item.request_pr_docs = {
    init() {
        abcsetup.setTitle('Request Item PR Documentation');

        // Change the tooltip from the first 2 column headers
        $('table.datatable').find('th').eq(0).attr('title', 'Toggle all visible items');
        $('table.datatable').find('th').eq(1).attr('title', 'Select the priority for all visibile items');

        // The toggle all checkbox in the header was clicked
        $(document).on('click', '[name=select_all]', function() {
            $('.checkbox-row').not(':disabled').attr('checked', $(this).is(':checked'));
        });

        // The select all priority in the header was change
        $(document).on('change', '[name=all_priority]', function() {
            $('.select-row').val($(this).val());
            $('.checkbox-row').not(':disabled').attr('checked', $(this).val() != '');
        });

        // A priority dropdown was changed on an item's row
        $(document).on('change', '.select-row', function() {
            $(this).closest('tr').find('.checkbox-row').not(':disabled').attr('checked', $(this).val() != '');
        });

        // Request button clicked
        $(".btn-submit").on("click", function () {
            if ($('.checkbox-row:checked').not(':disabled').length == 0) {
                abcsetup.alerts.show("Error Submitting Data", "Please select at least one item to request PR Documentation");
                return false;
            }

            return true;
        });

        // Upload SAP number button clicked
        $(document).on("change", "#import_sap_num_file", function () {
            // Load the specified excel file into a multidimensional array
            abcsetup.excel.readFile($("#import_sap_num_file")[0], function(sap_nums) {
                // Join together all column A values with a comma
                var sap_num_search = sap_nums[0].join(",");
                $('table.datatable').find('th').eq(4).addClass('filtered');
                $('table.datatable').find('th').eq(4).find('.datatable-column-filter-btn').data('filter', sap_num_search).addClass('active');
                $('table.datatable').DataTable().columns(4).search(sap_num_search).draw();

                abcsetup.blockUI(true);
            });

            $(this).blur();
            return false;
        });
    }
}
